import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {TextEditorService} from '../shared/services/text-editor.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-edit-cultural-initiative-about',
  templateUrl: './edit-cultural-initiative-about.component.html',
  styleUrls: ['./edit-cultural-initiative-about.component.css']
})
export class EditCulturalInitiativeAboutComponent implements OnInit {

  @Input() content: string;
  @Output() newItemEvent = new EventEmitter<string>();
  editorConfig;

  constructor(
    private textEditorService: TextEditorService,
  ) {
  }

  ngOnInit(): void {
    this.editorConfig = this.textEditorService.editorConfig;
  }

  contentChanged(): void {
    this.newItemEvent.emit(this.content);
  }

}
